import React, { useLayoutEffect, useRef } from 'react';
import { formatDate } from '../utils/date';
import { applyFieldTextLayout, resolveFieldValue } from '../utils/formFieldLayout';

export default function PdfFieldTextBox({
    field,
    values,
    className = '',
    style = null,
    color = '#111827',
    fontScale = 1,
    isActive = false,
}) {
    const wrapperRef = useRef(null);
    const textRef = useRef(null);
    const value = resolveFieldValue(field, values);

    useLayoutEffect(() => {
        if (!wrapperRef.current || !textRef.current || !field) return;
        applyFieldTextLayout({
            wrapper: wrapperRef.current,
            textNode: textRef.current,
            field,
            value,
            baseFontSize: (Number(field.fontSize) || 12) * fontScale,
            fontScale,
            color,
            formatDateFn: formatDate,
        });
    }, [color, field, fontScale, value]);

    return (
        <div
            ref={wrapperRef}
            className={`${className}${isActive ? ' active' : ''}`}
            style={style || undefined}
        >
            <span ref={textRef} />
        </div>
    );
}
